
import $ from 'jquery';
import screenSize from '../services/screen_size';
import componentize from '../utils/componentize';

export default function () {
    componentize({
        query: '.reading-bar',

        initialize: function () {
            const isSponsored = $('.-custom-content').length;

            if (screenSize.getSize() !== 'small' && screenSize.getSize() !== 'medium' && !isSponsored) {
                const $window = $(window);
                this.onScrollFn = this.onScroll.bind(this);
                this.onResizeFn = this.onScroll.bind(this);
                this.running = true;

                $window.on('scroll', this.onScrollFn);
                $window.on('resize', this.onResizeFn);
                let psuedoStyleSheet = document.createElement('style');
                document.head.appendChild(psuedoStyleSheet);
                this.psuedoStyleSheet = psuedoStyleSheet;

                this.postFull = document.querySelector('.fc-post-full') || document.querySelector('.fc-short-reads');
                if (this.classList.contains('fast-feed')) {
                    this.isFastFeed = true;
                    this.getArticleBounds();

                    this.currentArticleSpan = this.querySelector('.current-article');
                    if (this.querySelector('.total-articles')) {
                        this.querySelector('.total-articles').innerHTML = this.articleBounds.length - 1;
                    }
                } else {
                    this.appearAt = $('header').height();
                }
                this.onScroll();
            }
        },

        attachedCallback: function () {
            this.initialize();
        },

        onScroll: function () {
            var postFullHeight = this.postFull.offsetHeight;
            var docHeight = document.body.scrollHeight - window.innerHeight;
            var progressHeight = postFullHeight <= docHeight ? postFullHeight : docHeight;
            if (window.scrollY > this.appearAt) {
                this.style.top = '0';
            } else {
                this.style.top = '-60px';
            }
            this.setProgressBar(window.scrollY / progressHeight);

            if (this.isFastFeed) {
                let currentArticle = this.getCurrentArticle(window.scrollY);
                if (this.currentArticleSpan) {
                    this.currentArticleSpan.innerHTML = currentArticle;
                }
            }
        },
        setProgressBar: function (percent) {
            if (this.psuedoStyleSheet) {
                this.psuedoStyleSheet.innerHTML = `.reading-bar:after { width: ${ percent * 100 }%}`;
            }
        },
        getArticleBounds: function () {
            let articles = this.postFull.querySelectorAll('article h2');
            this.articleBounds = [];
            [].forEach.call(articles, article => {
                this.articleBounds.push((article.getBoundingClientRect().bottom | 0) + window.scrollY - 300);
            });
            this.appearAt = this.articleBounds[1];
        },
        getCurrentArticle: function (scrollY) {
            var currentIndex = 0;
            for (let i = 0; i < this.articleBounds.length; i++) {
                if (scrollY > this.articleBounds[i]) currentIndex = i;
            }

            return currentIndex || 1;
        }
    });
}
